import { render, staticRenderFns } from "./ViewUnapprovedSupply.vue?vue&type=template&id=79d8c752&"
import script from "./ViewUnapprovedSupply.vue?vue&type=script&lang=js&"
export * from "./ViewUnapprovedSupply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports